import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {WebCamModule} from 'ack-angular-webcam';

import {ProofOnWebPage} from './proof-on-web';

@NgModule({
  declarations: [
    ProofOnWebPage,
  ],
  imports: [
    IonicPageModule.forChild(ProofOnWebPage),
    WebCamModule,
  ],
  exports: [
    ProofOnWebPage
  ]
})
export class ProofOnWebPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/proof-on-web/proof-on-web.module.ts